import React from "react";

const Banner = (props) => {
  const { title, desc, cssClass, imageUrl = '../../../assets/img/contact-banner-bg.jpg' } = props;
  return (
    <section className={`inner-banner-section ${cssClass}`}

      style={{
        backgroundImage: `url("${imageUrl}")`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
        height: ""
      }}>
      <div className="container" data-aos="fade-up" data-aos-duration="1500">
        <h2 className="title">{title}</h2>
        <p className="intro-text">{desc}</p>

      </div>
    </section>
  );
};

export default Banner;
